export const GET_ASSETS = 'GET_ASSETS';
export const GET_ASSETS_REFERENCES = 'GET_ASSETS_REFERENCES';